module.exports = __webpack_public_path__ + "static/media/agro.20ef685d.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/cat/agro.png
// module id = 108
// module chunks = 0